import * as React from 'react';

function SvgFacebookColour(props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.308 2.147A5.308 5.308 0 002 7.454V22.68a5.308 5.308 0 005.308 5.308h15.226a5.307 5.307 0 005.308-5.308V7.454a5.307 5.307 0 00-5.308-5.307H7.308z"
        fill="url(#FacebookColour_svg__paint0_linear)"
      />
      <mask
        id="FacebookColour_svg__a"
        maskUnits="userSpaceOnUse"
        x={12}
        y={5}
        width={13}
        height={23}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12.48 5.503h11.773v22.484H12.48V5.503z"
          fill="#fff"
        />
      </mask>
      <g mask="url(#FacebookColour_svg__a)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M21.869 9.25h2.384V5.503H20.68s-2.246-.055-3.678 1.806c0 0-.975.92-.99 3.612v2.81H12.48v3.978h3.532v10.279h4.072V17.709h3.503l.489-3.978h-3.992v-2.81h-.001c.01-.314.15-1.699 1.786-1.67z"
          fill="#fff"
        />
      </g>
      <defs>
        <linearGradient
          id="FacebookColour_svg__paint0_linear"
          x1={-9.974}
          y1={15.434}
          x2={15.417}
          y2={40.577}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#5B7DC7" />
          <stop offset={1} stopColor="#3F5FA0" />
        </linearGradient>
      </defs>
    </svg>
  );
}

export default SvgFacebookColour;
